import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { TabPanel, TabView } from 'primereact/tabview';
import TLScoreCardFilter from '../tLScoreCardFilter/TLScoreCardFilter';
import CoachingActionPlanScoreCardDashboard from './components/CoachingActionPlanScoreCardDashboard';
import ActiveActionPlans from '../activeActionPlans/ActiveActionPlans';
import { AssociateScoresTable } from './components/AssociateScoresTable';
import './prepareStep.scss';
import ActionPlans from './components/ActionPlans/ActionPlans';

export const PrepareStep: React.FC = () => {
    const [inputmonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputyear, setYear] = useState(new Date().getFullYear());
    const [scorecardVersion, setScorecardVersion] = useState(0);
    const [empNum, setAgentNumber] = useState<any>();
    const [isActionPlansExpanded, setIsActionPlansExpanded] = useState(false);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        sessionStorage.removeItem('cap_nav_intent');
        navigate(location.pathname, {
            replace: true,
            state: null
        });
    }, []);

    return (
        <div className="step-placeholder">
            <div>
                <h5>Scorecard</h5>
                <TLScoreCardFilter
                    scorecardVersionValue={setScorecardVersion}
                    setAgentNumber={setAgentNumber}
                    inputmonth={inputmonth}
                    setInputMonth={setMonth}
                    inputyear={inputyear}
                    setInputYear={setYear}
                />
            </div>
            <TabView className='mt-2' activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header="Dashboard">


                    <div className='pt-3'>
                        <Accordion activeIndex={0}>
                            <AccordionTab header="Prepare: Agent Performance">
                                <h5>Last 30 Day Rollup</h5>
                                <CoachingActionPlanScoreCardDashboard
                                    empNum={empNum}
                                    inputmonth={inputmonth}
                                    inputyear={inputyear}
                                    scorecardVersion={scorecardVersion}
                                />
                            </AccordionTab>
                        </Accordion>
                    </div>


                    <div className='row' style={{ paddingTop: '10px' }}>
                        <div className={isActionPlansExpanded ? 'col-md-7' : 'col-md-11'}>
                            {/* <h4>Agents in Scorecard</h4> */}
                            {/* Next Best Action Table */}
                            <div className="mt-4">
                                <div className="flex justify-content-between align-items-center mb-3">
                                    <p className="text-sm text-color-secondary mb-0">
                                        Click on any arrow to create or follow up a Coaching Action Plan. You need to create at least one action plan for all agents each month.
                                    </p>
                                    <h4>Next Best Action</h4>

                                </div>
                                <AssociateScoresTable scorecardVersionId={scorecardVersion} />
                            </div>
                        </div>
                        <div className={isActionPlansExpanded ? 'col-md-5 pt-2' : 'col-md-1'}>
                            <span
                                className={isActionPlansExpanded ? "expand-icon" : "expand-icon collapsed-action-plans"}
                                role="button"
                                tabIndex={0}
                                onClick={() => setIsActionPlansExpanded(prev => !prev)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        setIsActionPlansExpanded(prev => !prev);
                                    }
                                }}
                            >
                                <i className="pi pi-chevron-down" /> Active Action Plans
                            </span>
                            <div style={{ display: isActionPlansExpanded ? 'inline' : 'none' }}>
                                <ActiveActionPlans
                                    scorecardVersionId={scorecardVersion}
                                />
                            </div>
                        </div>
                    </div>
                </TabPanel>
                <TabPanel header="Action Plans">
                    <ActionPlans scorecardVersionId={scorecardVersion} />
                </TabPanel>
            </TabView>
        </div>
    );
};